// =====================================
//	讀取 modal
//
//	@author: Gray
//	@time 2016 / 09 / 05
// =====================================

window.InifECMobileApp.directive('loadingModal', ['$rootScope', '$ngModal', '$timeout',
	function ($rootScope, $ngModal, $timeout) {

		var _dir = {};

		var controller = ['$scope', function($scope) {

            // --------------------------------
            // [private] 開啟讀取modal
            // --------------------------------
            var openLoadingModal = function(data) {

                $scope.title = data.title;
                $scope.type = 'loading';

                openModal();
            }

            // --------------------------------
            // [private] 開啟讀取成功modal
            // --------------------------------
            var openSuccessModal = function(data) {

                $scope.title = data.title;
                $scope.type = 'success';

                openModal();

                // 兩秒後自動關閉成功視窗
                $timeout(function() {
                    closeModal();
                }, 2000);
            }

            // --------------------------------
            // [private] 開啟失敗modal
            // --------------------------------
            var openErrorModal = function(data) {

                $scope.title = data.title;
                $scope.type = 'error';

                openModal();
            }

            // --------------------------------
            // 關閉modal（讀取狀態不能關）
            // --------------------------------
            var cancel = function() {

                if($scope.type == 'loading') {
                    return;
                }

                closeModal();
            }

            // ===============================
            //  開啟 modal
            // ===============================
            var openModal = function() {

            	$ngModal.openModal('loading-modal');
            }

            // ===============================
            //  關閉 modal
            // ===============================
            var closeModal = function() {

            	$ngModal.closeModal('loading-modal');
            }

            /*==========================
                Events
            ==========================*/            
            $scope.$on('OPEN_LOADING_MODAL', function(event, data) {

                if(data) {
                    openLoadingModal(data);
                }
            });

            $scope.$on('OPEN_LOADING_SUCCESS_MODAL', function(event, data) {

                if(data) {
                    openSuccessModal(data)   
                }
            });

            $scope.$on('OPEN_LOADING_ERROR_MODAL', function(event, data) {

                if(data) {
                    openErrorModal(data)   
                }
            });

            $scope.$on('CLOSE_LOADING_MODAL', function(event, data) {

                closeModal();
            });

            /*==========================
                Members
            ==========================*/
            $scope.title = undefined;
            $scope.type = 'loading';

            /*==========================
                Methods
            ==========================*/
            $scope.cancel = cancel; // 關閉modal（讀取狀態不能關）

            /*==========================
                init
            ==========================*/

		}]

		_dir.restrict = "E";
		_dir.scope = true;
		_dir.templateUrl = "mobile/partials/modal/loading_modal.html";
		_dir.controller = controller;

		return _dir;
	}]
);